export default "__VITE_ASSET__f9e66276__"